'use client';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useBlockPart } from '@akademi/site-builder-runtime';

/**
 * Filter pills for the "Up next" rail (All / Watched / Unwatched).
 */
export interface UpNextFilterPillsProps {
  filters?: Array<{ key: string; label: string }>;
  active?: string;
  onChange?: (key: string) => void;
}

/** The stock All / Unwatched / Watched pills, built per render so a
 *  language switch relabels them. */
const defaultFilters = (t: (key: string) => string) => [
  { key: 'all', label: t('upNext.filter.all') },
  { key: 'unwatched', label: t('upNext.filter.unwatched') },
  { key: 'watched', label: t('upNext.filter.watched') },
];

export function UpNextFilterPills({
  filters: authoredFilters,
  active: controlledActive,
  onChange,
}: UpNextFilterPillsProps) {
  const { t } = useTranslation('site-builder-blocks');
  const part = useBlockPart();
  const filters = authoredFilters ?? defaultFilters(t);
  const [local, setLocal] = useState(filters[0]?.key ?? 'all');
  const active = controlledActive ?? local;
  return (
    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }} {...part('filter')}>
      {filters.map((f, i) => {
        const isActive = active === f.key;
        return (
          <button
            key={f.key}
            type="button"
            {...part('tab', i)}
            onClick={() => {
              setLocal(f.key);
              onChange?.(f.key);
            }}
            style={{
              padding: 'var(--space-1-5, 6px) var(--space-3, 12px)',
              borderRadius: 999,
              border:
                '1px solid ' +
                (isActive
                  ? 'var(--color-brand-500, #3b5bdb)'
                  : 'var(--color-border, rgba(0,0,0,0.12))'),
              background: isActive ? 'var(--color-brand-500, #3b5bdb)' : 'transparent',
              color: isActive ? '#fff' : 'var(--color-text-primary, #18181b)',
              fontSize: 'var(--font-size-xs, 12px)',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            {f.label}
          </button>
        );
      })}
    </div>
  );
}
